export default "__VITE_ASSET__c3YX9gie__"